/* eslint-disable no-useless-escape */
import React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { Link } from '@tvg/fuse/link';
import { NameProps } from './NameProps';
import styles from './Name.module.css';

const slugifyBrand = (name: string): string => {
  let value = name
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/(\d)\s*\-\s*(?=\d)/g, '$1-to-')
    .replace(/\+/g, '-plus-')
    .replace(/(\D)\s*\/\s*(\D)/g, '$1-or-$2')
    .replace(/&|'n'/g, '-and-')
    .replace(/=/g, '-equivalent-');

  value = value
    .replace(/(\d)\sx\s(\d)/g, '$1x$2')
    .replace(/(\D)\./g, '$1-')
    .replace(/\%/g, '-pct')
    .replace(/[\'\-\,\(\)\\\:\!\?]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return value.trim().toLowerCase().replace(/\s+/g, '-');
};

function Name({ brand, name }: NameProps) {
  return (
    <Typography tag="h1" size="4" className={styles.container}>
      {brand && (
        <Link
          className={styles.brand}
          data-testid="product_brand"
          size="large"
          href={`/browse/brand--${slugifyBrand(brand)}`}
        >
          {brand}
        </Link>
        // <span className={styles.brand} dangerouslySetInnerHTML={{ __html: brand }} />
      )}
      <span dangerouslySetInnerHTML={{ __html: name }} data-testid="product_title" />
    </Typography>
  );
}

export default Name;
